
import React, { useEffect, useState } from 'react';
import DialogActions from '@mui/material/DialogActions';
import { MenuItem, Checkbox, ListItemText, TextField, TextareaAutosize, Stack } from "@mui/material";
import Select from "@mui/material/Select";
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import axios from '../../../utils/fvAxios';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import _ from "lodash";
import { ToastContainer, toast } from 'react-toastify';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';


export default function OutsideNetworkEmailPage({ DialogClose, ClientId, INFO, CCandBCCInfo, VendorSummary, LocationsList, RisklevelList, VendorTypeListInfo, To, Body, SetBody, SetTo }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };
    // const [CCandBCCInfo, setCCandBCCInfo] = useState([]);
    // const [LocationsList, setLocationsList] = React.useState([]);
    // const [RisklevelList, setRisklevelList] = React.useState([]);




    const [CCID, setCCID] = useState([]);
    const [BCCID, setBCCID] = useState([]);
    const [Comment, setComment] = useState("");
    const [Location, setLocation] = useState([]);
    const [MySelfCC, setMySelfCC] = useState(false);
    const [MySelfBCc, setMySelfBCc] = useState(false);
    const [RisklevelId, setRisklevelId] = React.useState("");
    const [VendorTypeId, setVendorTypeId] = React.useState("");

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    // useEffect(() => {
    //     Details();
    // }, []);

    // async function Details() {
    //     const res = await axios.get("MyAccount/GetCCAndBCCListForEmailVendor?orgID=" + ClientId);
    //     setCCandBCCInfo(res?.data?.data);

    //     axios.get("Common/GetLocationsByClientId?clientId=" + ClientId)
    //         .then((res) => {
    //             setLocationsList(res?.data?.data);
    //         }).catch(err => {
    //             console.log(err);
    //         })

    //     const resp = await axios.get("Common/GetRiskLevelWithDetailsByClientId?clientId=" + ClientId);
    //     setRisklevelList(resp?.data?.data);

    //     axios.get("AdminVendors/GetInvitationTemplateAndToEmail?clientId=" + ClientId + "&vendorId=" + INFO?.orgId)
    //         .then((res) => {
    //             setBody(res?.data?.data?.item1);
    //             setTo(res?.data?.data?.item2);
    //         }).catch(err => {
    //             console.log(err);
    //         })

    //     axios.get("AdminVendors/GetVendorSummaryForOutsideNetwork?clientId=" + ClientId + "&vendorId=" + INFO?.orgId)
    //         .then((res) => {
    //             setVendorSummary(res?.data?.data);
    //             setVendorSummaryStatuses(res?.data?.data?.statuses);
    //         }).catch(err => {
    //             console.log(err);
    //         })
    // }

    const [open, setOpen] = React.useState(false);
    const [DisInvitation, setDisInvitation] = React.useState(false);

    const DialogOpenClick = () => {
        setOpen(true);
    };
    const DialogCloseClick = () => {
        setOpen(false);
    };
    const Clear = () => {
        SetBody("");
        SetTo("");
        setComment("");
        setLocation([]);
        setMySelfCC(false);
        setMySelfBCc(false);
        setCCID([]);
        setBCCID([]);
        setVendorTypeId("");
        DialogClose();
        DialogCloseClick();
    }
    const SendEmail = async () => {
        setDisInvitation(true);
        const data = {
            "vendorId": INFO?.orgId,
            "invitationType": 2,
            "locations": Location?.toString(),
            "riskLevel": RisklevelId,
            "comments": Comment,
            "isSendMeCC": MySelfCC,
            "isSendMeBCC": MySelfBCc,
            "sendCC": CCID?.toString(),
            "sendBCC": BCCID?.toString(),
            "toAddress": To,
            "htmlTemplate": Body,
            "clientId": ClientId,
            "pqId": INFO?.pqId,
            "isERI": false,
            "clientContractId": VendorTypeId == "" ? 0 : VendorTypeId
        }
        const res = await axios.post("AdminVendors/PostOutsideInvitation", data);
        if (res?.data?.responseCode == 100) {
            toastNotify(res?.data?.responseMessage, true);
            Clear();
            setDisInvitation(false);
        } else {
            toastNotify(res?.data?.responseMessage, false);
            setDisInvitation(false);
        }
    }


    return (
        <>
            <ToastContainer />
            <Dialog fullScreen={fullScreen} open={open} onClose={DialogCloseClick}>
                <div style={{ marginLeft: "auto" }}>
                    <span className='mx-2' onClick={DialogCloseClick} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
                </div>

                <DialogContent sx={{ padding: "48px 48px" }} >
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                            inlineSize: "350px"
                        }}
                    >
                        <span style={{ fontSize: "larger" }} >{INFO?.orgName}</span>
                    </DialogTitle>

                    <DialogActions >
                        <div>
                            <div className='mt-3' >
                                <span style={{ color: "#3E4A62" }}>Location</span>
                                <br />
                                <Select
                                    labelId="docs-label"
                                    id="docs-select"
                                    multiple
                                    size='small'
                                    sx={{ width: "300px", overflow: "hidden" }}
                                    name="Site Safety Representive"
                                    value={Location || []}
                                    MenuProps={MenuProps}
                                    renderValue={(selected) =>
                                        selected
                                            .map((value) => LocationsList?.find((doc) => doc?.value === value)?.key)
                                            .filter((text) => text !== undefined)
                                            .join(", ")
                                    }
                                    onChange={(e) => setLocation(e.target.value)}
                                >
                                    <MenuItem key="Select All" hidden={LocationsList?.length == 0}>
                                        <Checkbox
                                            id="select-all-checkbox"
                                            indeterminate={
                                                Location?.length > 0 && Location?.length < LocationsList?.length
                                            }
                                            checked={Location?.length === LocationsList?.length}
                                            onChange={(event) => {
                                                if (event?.target?.checked) {
                                                    setLocation(LocationsList?.map((doc) => doc?.value));
                                                } else {
                                                    setLocation([]);
                                                }
                                            }}
                                        />
                                        <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                            Select All
                                        </label>
                                    </MenuItem>

                                    {LocationsList?.map((r, i) => (
                                        <MenuItem key={i} value={r?.value}>
                                            <Checkbox checked={Location?.indexOf(r?.value) > -1} />
                                            <ListItemText primary={r?.key} />

                                        </MenuItem>
                                    ))}
                                </Select>
                                {/* <Select
                                    labelId="docs-label"
                                    id="docs-select"
                                    size='small'
                                    sx={{ width: "300px", overflow: "hidden" }}
                                    name="Site Safety Representive"
                                    value={Location || ""}
                                    MenuProps={MenuProps}
                                    onChange={(e) => setLocation(e.target.value)}
                                >
                                    {LocationsList?.map((r) => (
                                        <MenuItem key={r?.key} value={r?.value}>
                                            {r?.key}
                                        </MenuItem>
                                    ))}
                                </Select> */}
                            </div>
                            <div className='mt-3' >
                                <span style={{ color: "#3E4A62" }}>Risk Level</span>
                                <br />
                                <Select
                                    sx={{
                                        '& legend': { display: 'none' },
                                        '& fieldset': { top: 0 },
                                        width: "300px",
                                    }}
                                    labelId="Risk"
                                    id="Risk"
                                    size="small"
                                    MenuProps={MenuProps}
                                    value={RisklevelId}
                                    onChange={(e) => setRisklevelId(e.target.value)}
                                >
                                    {RisklevelList?.map((item, index) => (
                                        <MenuItem key={index} value={item?.risk}>
                                            {item?.risk}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                            <div className='mt-3'>
                                <span style={{ color: "#3E4A62" }}>Vendor Type </span>
                                <br />
                                <Select
                                    sx={{ width: "300px", overflow: "hidden" }}
                                    labelId="demo-multiple-name-label"
                                    value={VendorTypeId || ""}
                                    id="demo-multiple-name"
                                    size="small"
                                    onChange={(e) => setVendorTypeId(e.target.value)}
                                    MenuProps={MenuProps}
                                    disabled={VendorTypeListInfo?.length == 0}
                                >
                                    {VendorTypeListInfo?.map((r, i) =>
                                        <MenuItem key={i} value={r?.key} > {r?.value}</MenuItem>
                                    )}
                                </Select>
                            </div>

                            <div className='mt-3' >
                                <span style={{ color: "#3E4A62" }}>Comments</span>
                                <br />
                                <TextareaAutosize
                                    minRows={3}
                                    id="Comments"
                                    name="Comments"
                                    placeholder="Comments"
                                    className="form-control text-feild-custom "
                                    size='small'
                                    value={Comment || ""}
                                    onChange={(e) => setComment(e.target.value)}
                                />
                            </div>
                            <div className='mt-3' >
                                <Stack direction={"row"} spacing={11}>
                                    <span style={{ color: "#3E4A62" }}>Send via CC to </span>
                                    <Stack direction={"row"} spacing={2}>
                                        <span className="input-label-right text-muted" >Myself</span>
                                        <FormGroup>
                                            <FormControlLabel
                                                control={<Checkbox checked={MySelfCC} onChange={(e) => setMySelfCC(e.target.checked)} size="medium" />}
                                            />
                                        </FormGroup>
                                    </Stack>
                                </Stack>
                                <br />
                                <Select
                                    labelId="docs-label"
                                    id="docs-select"
                                    multiple
                                    size='small'
                                    sx={{ width: "300px", overflow: "hidden" }}
                                    name="Site Safety Representive"
                                    value={CCID || []}
                                    MenuProps={MenuProps}
                                    renderValue={(selected) =>
                                        selected
                                            .map((key) => CCandBCCInfo?.find((doc) => doc?.key === key)?.value)
                                            .filter((value) => value !== undefined)
                                            .join(", ")
                                    }
                                    onChange={(e) => setCCID(e.target.value)}
                                >
                                    {CCandBCCInfo?.map((r) => (
                                        <MenuItem key={r?.key} value={r?.key}>
                                            <Checkbox checked={CCID?.indexOf(r?.key) > -1} />
                                            <ListItemText primary={r?.value} />

                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                            <div className='mt-3'>
                                <Stack direction={"row"} spacing={10}>
                                    <span style={{ color: "#3E4A62" }}>Send via BCC to  </span>
                                    <Stack direction={"row"} spacing={2}>
                                        <span className="input-label-right text-muted" >Myself</span>
                                        <FormGroup>
                                            <FormControlLabel
                                                control={<Checkbox checked={MySelfBCc} onChange={(e) => setMySelfBCc(e.target.checked)} size="medium" />}
                                            />
                                        </FormGroup>
                                    </Stack>
                                </Stack>
                                <br />

                                <Select
                                    labelId="docs-label"
                                    id="docs-select"
                                    multiple
                                    size='small'
                                    sx={{ width: "300px", overflow: "hidden" }}
                                    name="Site Safety Representive"
                                    value={BCCID || []}
                                    MenuProps={MenuProps}
                                    renderValue={(selected) =>
                                        selected
                                            .map((key) => CCandBCCInfo?.find((doc) => doc?.key === key)?.value)
                                            .filter((value) => value !== undefined)
                                            .join(", ")
                                    }
                                    onChange={(e) => setBCCID(e.target.value)}
                                >
                                    {CCandBCCInfo?.map((r) => (
                                        <MenuItem key={r?.key} value={r?.key}>
                                            <Checkbox checked={BCCID?.indexOf(r?.key) > -1} />
                                            <ListItemText primary={r?.value} />

                                        </MenuItem>
                                    ))}
                                </Select>

                            </div>
                            {/* <DialogActions > */}
                            <Stack direction={"row"} spacing={2} sx={{ padding: "20px" }}>
                                <Button variant="outlined" onClick={DialogCloseClick} sx={{ padding: "20px", backgroundColor: "#DBEAF4" }}>Cancel</Button>
                                <Button variant="contained" disabled={DisInvitation} onClick={SendEmail}> Send Invitation</Button>
                            </Stack>

                            {/* </DialogActions> */}
                        </div >
                    </DialogActions>
                </DialogContent>

            </Dialog>

            <DialogContent sx={{ padding: "48px 48px" }}>
                <DialogTitle
                    sx={{
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: 20,
                    }}
                >
                    <span style={{ fontSize: "larger" }} >{INFO?.orgName}</span>
                </DialogTitle>

                <DialogActions >

                    <div>
                        <div>
                            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} hidden={VendorSummary == "" ? true : false}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                    sx={{ backgroundColor: "#DBEAF4" }}
                                >
                                    <Typography sx={{ width: 'auto', flexShrink: 0, color: "#2A93DB", fontSize: "large" }}>Vendor Details</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <span className='text-muted' style={{ fontSize: "large" }} hidden={!VendorSummary?.name}>Name :</span>  {VendorSummary?.name}<br hidden={!VendorSummary?.name} />
                                    <span className='text-muted' style={{ fontSize: "large" }} hidden={!VendorSummary?.phoneNumber}>PhoneNumber :</span> {VendorSummary?.phoneNumber}<br hidden={!VendorSummary?.phoneNumber} />
                                    <span className='text-muted' style={{ fontSize: "large" }} hidden={!VendorSummary?.fax}>Fax :</span> {VendorSummary?.fax}<br hidden={!VendorSummary?.fax} />
                                    <span className='text-muted' style={{ fontSize: "large" }} hidden={!VendorSummary?.website}>Website :</span> {VendorSummary?.website}<br hidden={!VendorSummary?.website} />
                                    <span className='text-muted' style={{ fontSize: "large" }} hidden={!VendorSummary?.address}>Address :</span> {VendorSummary?.address}<br hidden={!VendorSummary?.address} />
                                    <span className='text-muted' style={{ fontSize: "large" }} hidden={!VendorSummary?.address1}>Address1 :</span> {VendorSummary?.address1}<br hidden={!VendorSummary?.address1} />
                                    <span className='text-muted' style={{ fontSize: "large" }} hidden={!VendorSummary?.address2}>Address2 :</span> {VendorSummary?.address2}<br hidden={!VendorSummary?.address2} />
                                    <span className='text-muted' style={{ fontSize: "large" }} hidden={!VendorSummary?.city}>City :</span> {VendorSummary?.city}<br hidden={!VendorSummary?.city} />
                                    <span className='text-muted' style={{ fontSize: "large" }} hidden={!VendorSummary?.state}>State :</span> {VendorSummary?.state}<br hidden={!VendorSummary?.state} />
                                    <span className='text-muted' style={{ fontSize: "large" }} hidden={!VendorSummary?.zip}>Zip :</span> {VendorSummary?.zip}

                                </AccordionDetails>
                            </Accordion>

                            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} hidden={VendorSummary?.statuses == "" ? true : false}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2bh-content"
                                    id="panel2bh-header"
                                    sx={{ backgroundColor: "#DBEAF4" }}
                                >
                                    <Typography sx={{ width: 'auto', flexShrink: 0, color: "#2A93DB", fontSize: "large" }}>Status(es)</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <span>{VendorSummary?.statuses?.map((q) => q).join(", ")}<br /></span>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')} hidden={VendorSummary?.rickLevels == "" ? true : false}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel3bh-content"
                                    id="panel3bh-header"
                                    sx={{ backgroundColor: "#DBEAF4" }}
                                >
                                    <Typography sx={{ width: 'auto', flexShrink: 0, color: "#2A93DB", fontSize: "large" }}>Risk Level(s)</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <span>{VendorSummary?.rickLevels?.map((q) => q).join(", ")}<br /></span>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')} hidden={VendorSummary?.biddings == "" ? true : false}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel4bh-content"
                                    id="panel4bh-header"
                                    sx={{ backgroundColor: "#DBEAF4" }}
                                >
                                    <Typography sx={{ width: 'auto', flexShrink: 0, color: "#2A93DB", fontSize: "large" }}>Bidding Interests</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <span>{VendorSummary?.biddings?.map((q) => q).join(", ")}<br /></span>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')} hidden={VendorSummary?.proficiancy == "" ? true : false}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel5bh-content"
                                    id="panel5bh-header"
                                    sx={{ backgroundColor: "#DBEAF4" }}
                                >
                                    <Typography sx={{ width: 'auto', flexShrink: 0, color: "#2A93DB", fontSize: "large" }}>Proficiancy</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <span>{VendorSummary?.proficiancy?.map((q) => q).join(", ")}<br /></span>
                                </AccordionDetails>
                            </Accordion>

                        </div>
                        <DialogActions >
                            <div className="login-help__buttonContainer mt-4">
                                <Button variant="contained" className="login-help-button-cancel mx-2" onClick={DialogClose}>Cancel</Button>
                                <Button variant="contained" className="login-button-request mx-2" onClick={DialogOpenClick}> Next</Button>
                            </div>

                        </DialogActions>
                    </div >
                </DialogActions>
            </DialogContent >
        </>
    )
}
